import { createSlice } from '@reduxjs/toolkit';

const commonState = {
    filter: {
        page: 1,
        pageSize: 10,
    },
    cursor: 0,
};

const initialState = {
    survey: {
        ...commonState,
        filter: {
            ...commonState.filter,
            isTesting: 0,
        },
    },
};

const wjSlice = createSlice({
    name: 'wj',
    initialState,
    reducers: {
        setSurveyFilter: (state, action) => void (state.survey.filter = action.payload),
        setSurveyCursor: (state, action) => void (state.survey.cursor = action.payload),
    },
});

export const wjActions = wjSlice.actions;

export default wjSlice;
